interface ExampleListProps {
    assistantExamples: string[];
    messagesLength: number;
    tmpImageUrlsLength: number;
    tempFileNamesLength: number;
    handleExampleClick: (example: string) => void;
}

export default function ExampleList({
    assistantExamples,
    handleExampleClick,
    messagesLength,
    tmpImageUrlsLength,
    tempFileNamesLength,
}: ExampleListProps) {
    const showComponent =
        tmpImageUrlsLength < 1 &&
        tempFileNamesLength < 1 &&
        assistantExamples &&
        assistantExamples.length > 0 &&
        messagesLength < 1
            ? true
            : false;

    return showComponent ? (
        <div className="relative mt-0 mb-3 py-6 grid grid-cols-4 gap-4 text-sm">
            {assistantExamples.map((example: any, index: any) => (
                <div
                    key={index}
                    className="border border-layout-borderColor text-gray-500 hover:text-layout-textcolor transition-all duration-100 rounded-xl p-4 flex justify-between gap-4 cursor-pointer"
                    onClick={() => {
                        handleExampleClick(example);
                    }}
                >
                    <div className="line-clamp-3 w-full">{example}</div>
                </div>
            ))}
        </div>
    ) : (
        <></>
    );
}
